import React, { useState } from 'react'
import { ModalBase } from './ModalBase'
import { useAuth } from '@/hooks/useAuth'

interface LoginModalProps {
    isOpen: boolean
    onClose: () => void
}

export const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose }) => {
    const { login, isLoading, error } = useAuth()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        try {
            await login({ email, password })
            onClose()
        } catch (err) {
            // Error handled by auth hook
        }
    }

    return (
        <ModalBase isOpen={isOpen} onClose={onClose}>
            <div className="text-center space-y-2 mb-6 mt-2">
                <h1 className="text-2xl font-bold tracking-tight text-text-main dark:text-white">
                    Log in to continue
                </h1>
                <p className="text-gray-500 dark:text-gray-400 text-base">
                    Access your free trial or premium courses instantly.
                </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4 mb-6">
                {error && (
                    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-200 p-3 rounded-lg text-sm font-medium">
                        {error}
                    </div>
                )}

                <div className="space-y-1.5">
                    <label className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400 ml-1">
                        Email
                    </label>
                    <input
                        className="input"
                        placeholder="name@example.com"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>

                <div className="space-y-1.5">
                    <label className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400 ml-1">
                        Password
                    </label>
                    <input
                        className="input"
                        placeholder="••••••••"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>

                <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full py-4 bg-primary text-black font-bold rounded-full shadow-lg hover:shadow-primary/30 hover:scale-[1.01] active:scale-[0.98] transition-all disabled:opacity-50"
                >
                    {isLoading ? 'Logging in...' : 'Log In'}
                </button>
            </form>

            <div className="grid grid-cols-2 gap-4">
                <button className="flex items-center justify-center gap-2 py-3 bg-white dark:bg-black/20 border border-gray-200 dark:border-white/10 rounded-lg font-bold text-sm hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                    Google
                </button>
                <button className="flex items-center justify-center gap-2 py-3 bg-white dark:bg-black/20 border border-gray-200 dark:border-white/10 rounded-lg font-bold text-sm hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                    Apple
                </button>
            </div>
        </ModalBase>
    )
}

export default LoginModal
